import React from 'react';
import Button from '../../../../components/Button';
import AddressAutocomplete from '../../../../components/AddressAutocomplete';
import GooglePreview from './GooglePreview';
import { AddCompetitorFormProps } from './types';

const AddCompetitorForm: React.FC<AddCompetitorFormProps> = ({
  addingCompetitor,
  newCompetitor,
  setNewCompetitor,
  setAddingCompetitor,
  handleAddCompetitor,
  googlePreview,
  loadingGoogleData,
  onAddressSelect,
  onClearPreview
}) => {
  if (!addingCompetitor) return null;

  return (
    <div style={{ 
      marginBottom: '2rem', 
      padding: '1.5rem', 
      backgroundColor: '#f8f9fa', 
      borderRadius: '4px' 
    }}>
      <h4 style={{ marginBottom: '1rem' }}>Add New Competitor</h4>
      
      {/* Streamlined Search Interface */}
      <div style={{ marginBottom: '1rem' }}>
        <AddressAutocomplete
          onSelect={onAddressSelect}
          label="Search for Competitor Business"
          placeholder="Type business name or address (e.g., 'Urban Air Warwick')"
          searchType="establishments"
          prioritizeBusinesses={true}
        />
        {loadingGoogleData && (
          <div style={{ 
            marginTop: '0.5rem', 
            color: '#1890ff',
            fontSize: '0.9rem'
          }}>
            🔄 Fetching business details from Google...
          </div>
        )}
      </div>

      {/* Manual Input Fields (for editing) */}
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '1rem',
        marginBottom: '1rem'
      }}>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#666' }}>
            Competitor Name
          </label>
          <input
            type="text"
            value={newCompetitor.name}
            onChange={(e) => setNewCompetitor({...newCompetitor, name: e.target.value})}
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              fontSize: '1rem'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#666' }}>
            Distance (miles)
          </label>
          <input
            type="number"
            value={newCompetitor.distance_miles || 0}
            onChange={(e) => setNewCompetitor({
              ...newCompetitor, 
              distance_miles: parseFloat(e.target.value)
            })}
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              fontSize: '1rem'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#666' }}>
            Threat Rating (1-5)
          </label>
          <input
            type="number"
            min="1"
            max="5"
            step="1"
            value={newCompetitor.threat_rating || 3}
            onChange={(e) => setNewCompetitor({
              ...newCompetitor, 
              threat_rating: parseInt(e.target.value)
            })}
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              fontSize: '1rem'
            }}
          />
        </div>
        <div>
          <label style={{ display: 'block', marginBottom: '0.5rem', color: '#666' }}>
            Competition Type
          </label>
          <select
            value={newCompetitor.competition_type || 'Potential'}
            onChange={(e) => setNewCompetitor({
              ...newCompetitor, 
              competition_type: e.target.value as 'Direct' | 'Indirect' | 'Potential'
            })}
            style={{ 
              width: '100%', 
              padding: '0.75rem',
              borderRadius: '4px',
              border: '1px solid #d9d9d9',
              fontSize: '1rem'
            }}
          >
            <option value="Direct">Direct Competitor</option>
            <option value="Indirect">Indirect Competitor</option>
            <option value="Potential">Potential Competitor</option>
          </select>
        </div>
      </div>

      {/* Enhanced Google Places Preview */}
      {googlePreview && <GooglePreview googlePreview={googlePreview} />}

      <div style={{ display: 'flex', gap: '0.5rem' }}>
        <Button onClick={handleAddCompetitor}>Save Competitor</Button>
        <Button 
          onClick={() => {
            setAddingCompetitor(false);
            onClearPreview();
          }} 
          style={{ 
            backgroundColor: 'white',
            color: '#1e1e1e',
            border: '1px solid #1e1e1e'
          }}
        >
          Cancel
        </Button>
        {googlePreview && (
          <Button 
            onClick={onClearPreview}
            style={{ 
              backgroundColor: '#fff',
              color: '#666',
              border: '1px solid #ccc'
            }}
          >
            Clear & Start Over
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddCompetitorForm;
